/**
 * Single source of truth for sidebar + page header icons.
 * Import icons here only; list/form/details headers should use getNavIconForPath().
 */
import {
  DashboardCustomize as DashboardIcon,
  Groups as PeopleIcon,
  AccessTime as AccessTimeIcon,
  AdminPanelSettings as ManagementIcon,
  Work as BureauIcon,
  CorporateFare as DepartmentIcon,
  TaskAlt as TaskIcon,
  CalendarMonth as CalendarMonthIcon,
  EventAvailable as EventIcon,
  PhotoLibrary as PhotoLibraryIcon,
  Handshake as HandshakeIcon,
  Inventory2 as InventoryIcon,
  Assignment as AssignmentIcon,
  Build as BuildIcon,
  Description as DocumentIcon,
  ReportProblem as PenaltyIcon,
  Analytics as AnalyticsIcon,
  AccessibilityNew as AccessibilityIcon,
  Star as StarIcon,
  ReceiptLong as ReceiptLongIcon,
  AccountBalance as BudgetIcon,
  BarChart as BarChartIcon,
  Receipt as ReceiptIcon,
  Assignment as RequirementIcon,
  Business as BusinessIcon,
  LocalShipping as LocalShippingIcon,
} from '@mui/icons-material';

/** Base path (no trailing slash) → icon component */
export const NAV_ICON_BY_PATH = {
  '/dashboard': DashboardIcon,
  '/accessibility-view': AccessibilityIcon,
  '/users': PeopleIcon,
  '/attendance': AccessTimeIcon,
  '/attendance/logs': ReceiptLongIcon,
  '/managements': ManagementIcon,
  '/bureaus': BureauIcon,
  '/departments': DepartmentIcon,
  '/calendar': CalendarMonthIcon,
  '/events': EventIcon,
  '/penalties': PenaltyIcon,
  '/tasks': TaskIcon,
  '/galleries': PhotoLibraryIcon,
  '/requirements': RequirementIcon,
  '/companies': BusinessIcon,
  '/partners': HandshakeIcon,
  '/sponsor-tiers': StarIcon,
  '/analyses': AnalyticsIcon,
  '/stocks': InventoryIcon,
  '/borrows': AssignmentIcon,
  '/claims': ReceiptIcon,
  '/parcels': LocalShippingIcon,
  '/budgets': BudgetIcon,
  '/budget-expenses': BarChartIcon,
  '/documents': DocumentIcon,
  '/maintenances': BuildIcon,
};

const SORTED_PATHS = Object.keys(NAV_ICON_BY_PATH).sort((a, b) => b.length - a.length);

/**
 * Resolve the nav icon for a route pathname (e.g. /users/edit/5 → PeopleIcon).
 */
export function getNavIconForPath(pathname = '') {
  const path = pathname.split('?')[0];
  const match = SORTED_PATHS.find(
    (base) => path === base || path.startsWith(`${base}/`),
  );
  return match ? NAV_ICON_BY_PATH[match] : PeopleIcon;
}

export default NAV_ICON_BY_PATH;
